export default "__VITE_ASSET__98fa4e0d__"